import { Col, Pagination, Row } from 'antd';

import type {
  IWorkJourneyManagementJourneyListItem,
  IWorkJourneyManagementJourneysMonthSummary,
} from '@src/models/interfaces/workJourneyManagement.interface';

import { WorkJourneyJourneysTable } from './components/WorkJourneyJourneysTable';
import { WorkJourneyManagementEmptyState } from '../WorkJourneyManagementEmptyState';
import { WorkJourneyMonthSidebar } from '../WorkJourneyMonthSidebar';
import styles from './styles.module.less';

const JOURNEYS_SIDEBAR_ISSUE_TYPES = [
  'below_minimum',
  'scheduled_absences',
  'staffing_shortage',
  'rejections',
] as const;

interface WorkJourneyJourneysSectionProps {
  summary: IWorkJourneyManagementJourneysMonthSummary | null;
  items: IWorkJourneyManagementJourneyListItem[];
  loading?: boolean;
  total?: number;
  page?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
}

export const WorkJourneyJourneysSection = ({
  summary,
  items,
  loading = false,
  total = 0,
  page = 1,
  pageSize = 10,
  onPageChange,
  onPreviousMonth,
  onNextMonth,
}: WorkJourneyJourneysSectionProps) => {
  if (!summary) {
    return loading ? null : (
      <WorkJourneyManagementEmptyState messageId="workJourney.management.empty.journeys" />
    );
  }

  return (
    <section>
      <Row gutter={[24, 24]} align="top">
        <Col xs={24} lg={6}>
          <WorkJourneyMonthSidebar
            month={summary.month}
            year={summary.year}
            issues={summary.issues}
            issueTypes={[...JOURNEYS_SIDEBAR_ISSUE_TYPES]}
            issueLabelPrefix="workJourney.management.journeys.sidebar.issue"
            onPreviousMonth={onPreviousMonth}
            onNextMonth={onNextMonth}
          />
        </Col>
        <Col xs={24} lg={18} className={styles.tableCol}>
          <WorkJourneyJourneysTable
            items={items}
            loading={loading}
            month={summary.month}
            year={summary.year}
          />
          {total > pageSize && onPageChange && (
            <div className={styles.pagination}>
              <Pagination
                current={page}
                pageSize={pageSize}
                total={total}
                onChange={onPageChange}
                showSizeChanger={false}
              />
            </div>
          )}
        </Col>
      </Row>
    </section>
  );
};
